import React, { ReactElement } from 'react';
import { ModularPageComponent as ModularPage } from 'b2b-apps/shop/content/components/ModularPage';
import { WrappedComponentProps as Props } from 'b2b-apps/shop/home/components/HomePage';

const HomePage = (props: Props): ReactElement => <ModularPage {...props} />;

export { HomePage };
